export default __webpack_public_path__ + "static/media/Emoji_Bar_Smiley.c97232b1.svg";